import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  IconButton,
  useTheme,
  Stack,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PlaceIcon from "@mui/icons-material/Place";

export const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "Planos",
      links: [
        { name: "Plano Individual", href: "#" },
        { name: "Plano Familiar", href: "#" },
        { name: "Plano Empresarial", href: "#" },
        { name: "Plano Odontológico", href: "#" },
        { name: "Plano Sênior", href: "#" },
      ],
    },
    {
      title: "Operadoras",
      links: [
        { name: "Amil", href: "#" },
        { name: "Bradesco Saúde", href: "#" },
        { name: "SulAmérica", href: "#" },
        { name: "Unimed", href: "#" },
        { name: "NotreDame Intermédica", href: "#" },
      ],
    },
    {
      title: "Links Úteis",
      links: [
        { name: "Política de Privacidade", href: "#" },
        { name: "Termos de Uso", href: "#" },
        { name: "Perguntas Frequentes", href: "#" },
        { name: "Blog de Saúde", href: "#" },
        { name: "Trabalhe Conosco", href: "#" },
      ],
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: "#1a2233", // Fundo escuro
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {/* Coluna de informações de contato */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                mb: 3,
                color: "white",
              }}
            >
              Maria Saúde - Consultora de Planos
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, opacity: 0.8 }}>
              Consultoria especializada em planos de saúde, oferecendo as
              melhores soluções para você, sua família ou empresa.
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <LocalPhoneIcon
                  sx={{ mr: 2, color: theme.palette.secondary.light }}
                />
                <Typography variant="body2">(11) 99999-9999</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <WhatsAppIcon
                  sx={{ mr: 2, color: theme.palette.secondary.light }}
                />
                <Typography variant="body2">(11) 99999-9999</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <EmailIcon
                  sx={{ mr: 2, color: theme.palette.secondary.light }}
                />
                <Typography variant="body2">
                  contato@mariasaude.com.br
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PlaceIcon
                  sx={{ mr: 2, color: theme.palette.secondary.light }}
                />
                <Typography variant="body2">
                  Av. Paulista, 1000 - Bela Vista, São Paulo - SP
                </Typography>
              </Box>
            </Box>

            <Stack direction="row" spacing={1}>
              <IconButton
                aria-label="Facebook"
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: theme.palette.primary.main },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                aria-label="Instagram"
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: theme.palette.primary.main },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                aria-label="LinkedIn"
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: theme.palette.primary.main },
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                aria-label="WhatsApp"
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: theme.palette.primary.main },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Stack>
          </Grid>

          {/* Colunas de links */}
          {footerLinks.map((section, index) => (
            <Grid item xs={12} sm={4} md={2} key={index}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, mb: 3, color: "white" }}
              >
                {section.title}
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", pl: 0, m: 0 }}>
                {section.links.map((link, idx) => (
                  <Box component="li" key={idx} sx={{ mb: 1.5 }}>
                    <Link
                      href={link.href}
                      underline="hover"
                      sx={{
                        color: "rgba(255, 255, 255, 0.7)",
                        transition: "color 0.2s",
                        "&:hover": {
                          color: theme.palette.secondary.light,
                        },
                      }}
                    >
                      {link.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}

          {/* Coluna de ANS */}
          <Grid item xs={12} sm={4} md={2}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, mb: 3, color: "white" }}
            >
              Regulamentação
            </Typography>
            <Box
              component="img"
              src="https://via.placeholder.com/120x60?text=ANS"
              alt="ANS - Agência Nacional de Saúde Suplementar"
              sx={{
                width: 120,
                height: 60,
                mb: 2,
                // backgroundColor: "white",
                padding: 1,
                borderRadius: 1,
              }}
            />
            <Typography
              variant="caption"
              sx={{ display: "block", opacity: 0.7 }}
            >
              Registro ANS: 123456
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255, 255, 255, 0.1)" }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © {currentYear} Maria Saúde. Todos os direitos reservados.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Desenvolvido por{" "}
            <Link href="#" color="inherit" underline="hover">
              Sua Empresa
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
